import React from 'react'
import { Field, Form } from 'react-final-form'

import { Alert } from '@cinch-labs/design-system'
import { Outline, Primary } from '@cinch/oxd-components/button/src'
import { required } from '@cinch/oxd-utils/validators/src'

import * as styles from './form.module.css'
import { TextFieldWrapper } from '../../../../final-form-wrappers/src'

interface GeocodeFormProps {
  onSubmit: (values: any) => any
  onCancel?: () => any
}

const GeocodeForm: React.FC<GeocodeFormProps> = ({ onSubmit, onCancel }) => {
  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit, pristine, submitting, submitFailed, submitError }) => (
        <form onSubmit={handleSubmit}>
          <Field
            id="locationInput"
            name="location"
            type="text"
            fullWidth={true}
            component={TextFieldWrapper}
            oxford={true}
            validate={required}
            label={'Postcode or town'}
            autoComplete="postal-code"
            placeholder={'e.g. SW15 1EQ'}
          />

          {submitFailed && submitError && <Alert oxford={true}>{submitError}</Alert>}

          <div className={styles.buttons}>
            {!!onCancel && (
              <Outline data-field="cancel" type="button" onClick={onCancel}>
                Cancel
              </Outline>
            )}
            <Primary
              data-field="submit"
              type="submit"
              disabled={pristine || submitting}
              oxdClassName={styles.button}
              oxford={true}
            >
              Save
            </Primary>
          </div>
        </form>
      )}
    />
  )
}

export default GeocodeForm
